<template>
  <div>
    <a-spin :spinning="isLoading">
      <br />
      <div class="grid grid-cols-6">
        <div class="col-span-6 mx-8">
          <Form v-model="form" />
        </div>
      </div>
      <div class="mx-10">
        <router-link to="/customers">
          <a-button>Cancel</a-button>
        </router-link>
        <a-button type="primary" @click="onSubmit" style="margin-left: 10px;"
          >Save</a-button
        >
        <a-button
          type="primary"
          @click="onSubmitAndKeep"
          style="margin-left: 10px;"
          >Save & Create other</a-button
        >
      </div>
    </a-spin>
  </div>
</template>

<script>
import Form from "@/components/Form/user-form.vue";

export default {
  components: {
    Form,
  },
  data() {
    return {
      isLoading: false,
      subindustries: null,
      mediaType: "drive",
      form: {
        email: null,
        password: null,
        business_type: null,
        plan: null,
      },
    };
  },
  methods: {
    async onSubmit() {
      const { success } = await this.createUser();
      if (success) {
        this.$router.push("/customers");
      }
    },
    async onSubmitAndKeep() {
      const { success } = await this.createUser();
      if (success) {
        this.$router.go(0);
      }
    },
    async createUser() {
      this.isLoading = true;
      const user = await this.$store.dispatch("CREATE_USER", this.form);

      this.isLoading = false;
      return user;
    },
  },
};
</script>

<style>
.advertisements__new__actions button ~ button,
.advertisements__new__actions a ~ a,
.advertisements__new__actions a ~ button,
.advertisements__new__actions button ~ a {
  margin-left: 10px;
}
.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
.custom_select--group .ant-row.ant-form-item {
  margin-bottom: 0 !important;
}
</style>
